import * as Filepond from 'filepond';
import localeDe from 'filepond/locale/de-de';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';

const requestFeatureDialog = document.getElementById('new-feature-request-dialog');

if (requestFeatureDialog) {
    const form = requestFeatureDialog.querySelector('form');
    const submitButton = requestFeatureDialog.querySelector('button[type="submit"]');
    const fileInput = requestFeatureDialog.querySelector('input[type="file"]');

    Filepond.registerPlugin(FilePondPluginFileValidateType);
    Filepond.registerPlugin(FilePondPluginFileValidateSize);

    const pond = Filepond.create(fileInput, {
        server: ajaxurl + '?action=indamed_upload_feature_request_file',
        credits: false,
        allowMultiple: true,
        instantUpload: true,
        ...localeDe,
        acceptedFileTypes: ['image/*', 'application/pdf'],
        maxFileSize: '5MB',
        fileValidateTypeLabelExpectedTypes: 'Nur Bilder oder PDF-Dateien erlaubt',
        // server: {
        //     url: ajaxurl,
        //     process: {
        //         url: '?action=indamed_upload_feature_request_file',
        //         method: 'POST',
        //         headers: {
        //             'X-WP-Nonce': indamedKundenportal.nonce
        //         },
        //         withCredentials: false,
        //         onload: (response) => {
        //             const data = JSON.parse(response);
        //             return data.data;
        //         }
        //     }
        // }
    });

    form.addEventListener('submit', (event) => {
        event.preventDefault();
        submitButton.disabled = true;
        submitButton.textContent = 'Bitte warten...';

        const formData = new FormData(form);

        fetch(ajaxurl, {
            method: 'POST',
            body: formData
        }).then(response => {
            if (response.ok) {
                response.json().then(data => {
                    if (data.success) {
                        window.location.href = data.data.permalink;
                    } else {
                        alert('Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.');
                    }
                });
            } else {
                alert('Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.');
            }
        }).catch(() => {
            alert('Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.');
        }).finally(() => {
            submitButton.disabled = false;
            submitButton.textContent = 'Absenden';
        });
    });
}